import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ben from '../assets/ben-default.png';
import speech from '../assets/ben-speach-close.png';
import open from '../assets/ben-speach-open.png';
import audio from '../assets/speech.wav';

function Cartoon({ messages, i = -1 }) {
  const [messageIndex, setMessageIndex] = useState(i);
  const [message, setMessage] = useState(undefined);
  const [src, setSrc] = useState(ben);
  const [wait, setWait] = useState(false);

  const [audioContext, setAudioContext] = useState(null);
  const [audioBuffer, setAudioBuffer] = useState(null);

  const debounceTimeout = useRef(null);
  const charInterval = useRef(null);

  useEffect(() => {
    const context = new AudioContext();
    setAudioContext(context);
    fetch(audio).then((response) => {
      response.arrayBuffer().then((arrayBuffer) => {
        context.decodeAudioData(arrayBuffer).then((audioBuffer) => {
          setAudioBuffer(audioBuffer);
          setAudioContext(context);
        });
      });
    });

    return () => {
      if (context) {
        context.close();
      }
    };
  }, []);

  useEffect(() => {
    if (messageIndex >= 0 && audioContext && audioBuffer) {
      let currentMessage = messages[messageIndex];
      let charIndex = 0;
      const source = audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.loop = true;
      source.start(0, Math.random() * audioBuffer.duration);
      const gainNode = audioContext.createGain();
      gainNode.gain.setValueAtTime(0.5, 0);
      source.connect(gainNode);
      gainNode.connect(audioContext.destination);

      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => setWait(false), 1000);

      if (charInterval.current) clearInterval(charInterval.current);
      setSrc(open);
      charInterval.current = setInterval(() => {
        setMessage(currentMessage.substring(0, charIndex));
        setSrc(Math.random() > 0.5 ? open : speech);
        charIndex++;
        if (charIndex > currentMessage.length) {
          source.stop();
          setSrc(speech);
          if (charInterval.current) clearInterval(charInterval.current);
        }
      }, 50);
      return () => {
        source.stop();
      };
    }
  }, [messageIndex, messages, audioContext, audioBuffer]);

  const onClick = () => {
    if (wait) return;
    setWait(true);
    setMessageIndex((messageIndex + 1) % messages.length);
  };

  return (
    <div className="cartoon">
      <img onClick={onClick} alt="cartoon" src={src} />
      <p>{message}</p>
    </div>
  );
}

Cartoon.propTypes = {
  messages: PropTypes.array.isRequired,
  i: PropTypes.number
};

export default Cartoon;
